import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { brandStyles, clientUrl, defaultBundleIndex, logoNode, money, ticketBundles } from './V2Helpers'
import V2PoweredBy from './V2PoweredBy'
import V2RefreshStrip from './V2RefreshStrip'

let stripeJsPromise = null

function stripePublishableKey() {
    return process.env.REACT_APP_STRIPE_MODE === "live"
        ? process.env.REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY || ""
        : process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY || ""
}

function loadStripeJs() {
    if (stripeJsPromise) return stripeJsPromise
    stripeJsPromise = new Promise((resolve, reject) => {
        if (window.Stripe) {
            resolve(window.Stripe(stripePublishableKey()))
            return
        }
        const script = document.createElement("script")
        script.src = "https://js.stripe.com/v3/"
        script.async = true
        script.onload = () => resolve(window.Stripe(stripePublishableKey()))
        script.onerror = () => reject(new Error("Could not load Stripe checkout."))
        document.head.appendChild(script)
    })
    return stripeJsPromise
}

export class V2BuyTickets extends Component {
    constructor(props) {
        super(props)
        const bundles = ticketBundles(props.event)
        const remaining = Math.max(0, Number((props.event || {}).maxPrizePool || 0) - Number((props.event || {}).prizePool || 0))
        const hasPrizePoolLimit = !(props.event || {}).isMajorLottery
        const preferredBundleIndex = defaultBundleIndex(bundles)
        const availableBundleIndex = bundles.findIndex((bundle) => !hasPrizePoolLimit || Number(bundle.price || 0) <= remaining)
        const selectedBundleIndex =
            bundles[preferredBundleIndex] && (!hasPrizePoolLimit || Number(bundles[preferredBundleIndex].price || 0) <= remaining)
                ? preferredBundleIndex
                : availableBundleIndex === -1
                    ? preferredBundleIndex
                    : availableBundleIndex
        this.state = {
            selectedBundle: selectedBundleIndex,
            phone: "",
            email: "",
            name: "",
            cardName: "",
            cardNumber: "",
            expiryMonth: "",
            expiryYear: "",
            cvc: "",
            optIn: false,
            addressNumber: "",
            addressStreet: "",
            addressSuburb: "",
            addressPostcode: "",
            addressState: "",
            loading: false,
            stripeReady: false,
            walletAvailable: false,
            complete: false,
            purchase: null,
            message: "",
            showTerms: false
        }
    }

    componentDidMount() {
        if (this.isStripeEvent()) this.setupStripe()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.isStripeEvent() && (prevProps.event || {}).paymentGateway !== "stripe") this.setupStripe()
        if (this.paymentRequest && prevState.selectedBundle !== this.state.selectedBundle) {
            const bundle = this.selectedBundle()
            if (bundle) {
                this.paymentRequest.update({
                    total: {
                        label: (this.props.event.name || this.props.event.title || "Split 50-50 tickets"),
                        amount: Math.round(Number(bundle.price || 0) * 100)
                    }
                })
            }
        }
    }

    componentWillUnmount() {
        if (this.cardElement) this.cardElement.unmount()
        if (this.paymentRequestButton) this.paymentRequestButton.unmount()
    }

    update = (field, value) => {
        this.setState({ [field]: value, message: "" })
    }

    expiryYears = () => {
        const currentYear = new Date().getFullYear()
        return Array.from({ length: 11 }, (_, index) => currentYear + index)
    }

    expiryMonths = () => [
        ["1", "January"],
        ["2", "February"],
        ["3", "March"],
        ["4", "April"],
        ["5", "May"],
        ["6", "June"],
        ["7", "July"],
        ["8", "August"],
        ["9", "September"],
        ["10", "October"],
        ["11", "November"],
        ["12", "December"]
    ]

    remainingPrizePool = () => {
        const event = this.props.event || {}
        return Math.max(0, Number(event.maxPrizePool || 0) - Number(event.prizePool || 0))
    }

    hasPrizePoolLimit = () => !((this.props.event || {}).isMajorLottery)

    isBundleDisabled = (bundle) => this.hasPrizePoolLimit() && Number(bundle && bundle.price ? bundle.price : 0) > this.remainingPrizePool()

    isStripeEvent = () => (this.props.event || {}).paymentGateway === "stripe"

    selectedBundle = () => ticketBundles(this.props.event)[this.state.selectedBundle]

    setupStripe = async () => {
        if (this.stripe || this.settingUpStripe) return
        const key = stripePublishableKey()
        if (!key) {
            this.setState({ message: "Stripe publishable key is not configured." })
            return
        }
        this.settingUpStripe = true
        try {
            this.stripe = await loadStripeJs()
            this.elements = this.stripe.elements()
            this.cardElement = this.elements.create("card", {
                hidePostalCode: true,
                style: {
                    base: {
                        color: "#0f172a",
                        fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
                        fontSize: "16px",
                        fontWeight: "700",
                        "::placeholder": { color: "#94a3b8" }
                    },
                    invalid: { color: "#b91c1c" }
                }
            })
            this.cardElement.mount("#v2-stripe-card-element")
            this.setupPaymentRequestButton()
            this.setState({ stripeReady: true })
        } catch (error) {
            this.setState({ message: error.message || "Could not load Stripe checkout." })
        } finally {
            this.settingUpStripe = false
        }
    }

    setupPaymentRequestButton = () => {
        const bundle = this.selectedBundle()
        if (!this.stripe || !this.elements || !bundle) return
        this.paymentRequest = this.stripe.paymentRequest({
            country: "AU",
            currency: "aud",
            total: {
                label: (this.props.event.name || this.props.event.title || "Split 50-50 tickets"),
                amount: Math.round(Number(bundle.price || 0) * 100)
            },
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: true
        })
        this.paymentRequest.on("paymentmethod", (event) => {
            this.setState({
                name: this.state.name || event.payerName || "",
                email: this.state.email || event.payerEmail || "",
                phone: this.state.phone || event.payerPhone || ""
            }, () => this.submitStripePaymentMethod(event.paymentMethod.id, event, this.stripePaymentMethodType(event.paymentMethod)))
        })
        this.paymentRequest.canMakePayment().then((result) => {
            if (!result) return
            this.setState({ walletAvailable: true }, () => {
                this.paymentRequestButton = this.elements.create("paymentRequestButton", {
                    paymentRequest: this.paymentRequest
                })
                this.paymentRequestButton.mount("#v2-payment-request-button")
            })
        }).catch(() => {})
    }

    accessCode = () => {
        try {
            return window.sessionStorage.getItem("s50-event-access-code:" + clientUrl(this.props.client)) || ""
        } catch (error) {
            return ""
        }
    }

    purchasePayload = (bundle, overrides = {}) => {
        const { client, event } = this.props
        return {
            v2: true,
            clientUrl: clientUrl(client),
            eventId: event.eventId,
            ticketCount: bundle.tickets,
            termsRevisionId: event.termsSnapshot && event.termsSnapshot.revisionId,
            phone: this.state.phone,
            email: this.state.email,
            name: this.state.name,
            cardName: this.state.cardName || this.state.name,
            cardNumber: this.state.cardNumber,
            expiryMonth: this.state.expiryMonth,
            expiryYear: this.state.expiryYear,
            cvc: this.state.cvc,
            optIn: this.state.optIn,
            accessCode: this.accessCode(),
            addressNumber: this.state.addressNumber,
            addressStreet: this.state.addressStreet,
            addressSuburb: this.state.addressSuburb,
            addressPostcode: this.state.addressPostcode,
            addressState: this.state.addressState,
            ...overrides
        }
    }

    handlePurchaseResponse = (response, walletEvent) => {
        if (response && response.success) {
            if (walletEvent) walletEvent.complete("success")
            this.setState({ loading: false, complete: true, purchase: response.purchase })
        } else {
            if (walletEvent) walletEvent.complete("fail")
            this.setState({
                loading: false,
                message: (response && response.message) || "There was an error processing your purchase. Please try again."
            })
        }
    }

    validateStripeDetails = () => {
        if (!this.state.name.trim()) return "Please enter your name."
        if (!this.state.phone.trim()) return "Please enter your mobile number."
        if (!this.state.email.trim()) return "Please enter your email address."
        return ""
    }

    stripePaymentMethodType = (paymentMethod) => {
        const walletType = paymentMethod && paymentMethod.card && paymentMethod.card.wallet && paymentMethod.card.wallet.type
        if (walletType === "apple_pay") return "apple_pay"
        if (walletType === "google_pay") return "google_pay"
        if (walletType === "link") return "link"
        if (paymentMethod && paymentMethod.type === "link") return "link"
        return "card"
    }

    submitStripePaymentMethod = (paymentMethodId, walletEvent, paymentMethodType = "card") => {
        if (!this.props.event.termsSnapshot) {
            if (walletEvent) walletEvent.complete("fail")
            this.setState({ message: "Please refresh the page to load the event terms before purchasing." })
            return
        }
        const bundle = this.selectedBundle()
        if (!bundle || this.isBundleDisabled(bundle)) {
            const message = "This ticket bundle would take the prize pool over the event limit. Please choose a smaller bundle."
            if (walletEvent) walletEvent.complete("fail")
            this.setState({ message })
            return
        }
        const detailError = this.validateStripeDetails()
        if (detailError) {
            if (walletEvent) walletEvent.complete("fail")
            this.setState({ message: detailError })
            return
        }
        this.setState({ loading: true, message: "" }, () => {
            this.props.purchase(this.purchasePayload(bundle, { stripePaymentMethodId: paymentMethodId, paymentMethodType }), (response) => {
                this.handlePurchaseResponse(response, walletEvent)
            })
        })
    }

    submitStripe = async () => {
        const bundle = this.selectedBundle()
        if (!bundle || this.isBundleDisabled(bundle)) {
            this.setState({ message: "This ticket bundle would take the prize pool over the event limit. Please choose a smaller bundle." })
            return
        }
        const detailError = this.validateStripeDetails()
        if (detailError) {
            this.setState({ message: detailError })
            return
        }
        if (!this.stripe || !this.cardElement) {
            this.setState({ message: "Stripe checkout is still loading. Please try again in a moment." })
            return
        }
        this.setState({ loading: true, message: "" })
        const result = await this.stripe.createPaymentMethod({
            type: "card",
            card: this.cardElement,
            billing_details: {
                name: this.state.name,
                email: this.state.email,
                phone: this.state.phone
            }
        })
        if (result.error) {
            this.setState({ loading: false, message: result.error.message || "Check your card details and try again." })
            return
        }
        this.submitStripePaymentMethod(result.paymentMethod.id, null, this.stripePaymentMethodType(result.paymentMethod))
    }

    submit = () => {
        if (!this.props.event.termsSnapshot) {
            this.setState({ message: "Please refresh the page to load the event terms before purchasing." })
            return
        }
        if (this.isStripeEvent()) {
            this.submitStripe()
            return
        }
        const { event } = this.props
        const bundles = ticketBundles(event)
        const bundle = bundles[this.state.selectedBundle]
        if (!bundle || this.isBundleDisabled(bundle)) {
            this.setState({ message: "This ticket bundle would take the prize pool over the event limit. Please choose a smaller bundle." })
            return
        }
        this.setState({ loading: true, message: "" }, () => {
            this.props.purchase(this.purchasePayload(bundle), (response) => this.handlePurchaseResponse(response))
        })
    }

    ticketNumbersLabel = () => {
        const purchase = this.state.purchase
        const event = this.props.event
        if (!purchase) return ""
        const start = Number(purchase.ticketIndex || 0)
        const count = Number(purchase.ticketCount || 0)
        if (!start || !count) return ""
        const end = start + count - 1
        const eventId = purchase.eventId || event.eventId || ""
        const startTicket = eventId ? eventId + "_" + start : "#" + start
        const endTicket = eventId ? eventId + "_" + end : "#" + end
        return count === 1 ? startTicket : startTicket + " - " + endTicket
    }

    buildTerms = () => {
        const document = this.props.event.termsSnapshot
        return document ? document.terms : []
    }

    renderTermsModal() {
        if (!this.state.showTerms) return null
        const terms = this.buildTerms()
        return (
            <div className="v2-modal-shell">
                <div className="v2-modal-card v2-terms-modal">
                    <button className="v2-modal-close" onClick={() => this.setState({ showTerms: false })}>×</button>
                    <h2>Terms and Conditions</h2>
                    {this.props.event.termsSnapshot && this.props.event.termsSnapshot.subtitle && <p className="v2-terms-subtitle">{this.props.event.termsSnapshot.subtitle}</p>}
                    {!terms.length && <p>Terms are unavailable. Please refresh the page before purchasing.</p>}
                    <ol className="v2-terms-list">
                        {terms.slice(0, -1).map((term, index) => <li key={index}>{term}</li>)}
                    </ol>
                    <p className="v2-terms-privacy">{terms[terms.length - 1]}</p>
                    {this.props.event.termsSnapshot && this.props.event.termsSnapshot.additionalTerms && (
                        <section className="v2-additional-terms">
                            <h3>Additional event terms</h3>
                            <p>{this.props.event.termsSnapshot.additionalTerms}</p>
                        </section>
                    )}
                    <button className="v2-primary-action v2-terms-back-button" onClick={() => this.setState({ showTerms: false })}>Back to buy tickets</button>
                </div>
            </div>
        )
    }

    render() {
        const { client, event } = this.props
        const brand = brandStyles(client, event)
        const bundles = ticketBundles(event)
        const selected = bundles[this.state.selectedBundle]
        const selectedDisabled = this.isBundleDisabled(selected)
        const hasDisabledBundles = this.hasPrizePoolLimit() && bundles.some((bundle) => this.isBundleDisabled(bundle))
        const cause = event.cause || client.name || "your organisation"
        const isStripeCheckout = this.isStripeEvent()
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }
        const overlayStyle = { backgroundColor: brand.overlayColor, opacity: brand.overlayOpacity }

        if (event.status === "draw-ready" || event.drawPending) {
            return (
                <div className="v2-public-page v2-buy-page" style={backgroundStyle}>
                    <V2RefreshStrip />
                    <div className="v2-public-overlay" style={overlayStyle} />
                    <main className="v2-buy-complete">
                        {logoNode(client, event, "v2-public-logo")}
                        <h1>Ticket sales closed</h1>
                        <p>This raffle is closed and the winning ticket has not been drawn yet.</p>
                        <button className="v2-primary-action" onClick={() => this.props.history.push("/" + clientUrl(client))}>Back to event</button>
                        <V2PoweredBy />
                    </main>
                </div>
            )
        }

        if (this.state.complete) {
            return (
                <div className="v2-public-page v2-buy-page" style={backgroundStyle}>
                    <V2RefreshStrip />
                    <div className="v2-public-overlay" style={overlayStyle} />
                    <main className="v2-buy-complete">
                        {logoNode(client, event, "v2-public-logo")}
                        <h1>Tickets purchased</h1>
                        <p>Your ticket link has been sent to your mobile number.</p>
                        {this.state.purchase ? <p className="v2-ticket-range">Tickets {this.ticketNumbersLabel()}</p> : null}
                        <button className="v2-primary-action" onClick={() => this.props.history.push("/" + clientUrl(client))}>Back to event</button>
                        <V2PoweredBy />
                    </main>
                </div>
            )
        }

        return (
            <div className="v2-public-page v2-buy-page" style={backgroundStyle}>
                <V2RefreshStrip />
                <div className="v2-public-overlay" style={overlayStyle} />
                {this.renderTermsModal()}
                <main className="v2-buy-layout">
                    <section className="v2-buy-hero">
                        {logoNode(client, event, "v2-public-logo")}
                        <span>Secure checkout</span>
                        <h1>Choose your tickets and support {cause}.</h1>
                        <p>Your ticket link is sent to your mobile number after payment.</p>
                        <button className="v2-back-button" onClick={() => this.props.history.push("/" + clientUrl(client))}>Back to event</button>
                    </section>
                    <section className="v2-checkout-card">
                        <span>Buy tickets</span>
                        <h2>{event.name || event.title}</h2>
                        <p>Tickets are sent by SMS.</p>
                        <label>Ticket bundle</label>
                        <div className="v2-bundle-list">
                            {bundles.map((bundle, index) => (
                                <button
                                    key={bundle.tickets + "-" + bundle.price}
                                    className={index === this.state.selectedBundle ? "selected" : ""}
                                    disabled={this.isBundleDisabled(bundle)}
                                    onClick={() => this.setState({ selectedBundle: index })}
                                >
                                    <strong>{bundle.tickets} tickets</strong>
                                    <span>{money(bundle.price)}</span>
                                </button>
                            ))}
                        </div>
                        {hasDisabledBundles ? (
                            <p className="v2-bundle-note">
                                Some bundles are unavailable because they would take the prize pool over {money(event.maxPrizePool || 0)}.
                            </p>
                        ) : null}
                        <div className="v2-form-section">
                            <h3>Personal details</h3>
                            {isStripeCheckout ? (
                                <input placeholder="Name" value={this.state.name} onChange={(e) => this.update("name", e.target.value)} />
                            ) : null}
                            <input placeholder="Mobile number" value={this.state.phone} onChange={(e) => this.update("phone", e.target.value)} />
                            <input placeholder="Email" value={this.state.email} onChange={(e) => this.update("email", e.target.value)} />
                            <label className="v2-checkbox">
                                <input type="checkbox" checked={this.state.optIn} onChange={(e) => this.update("optIn", e.target.checked)} />
                                <span>Send me updates from {cause}.</span>
                            </label>
                        </div>
                        <div className="v2-form-section">
                            <h3>Payment details</h3>
                            {isStripeCheckout ? (
                                <>
                                    <div id="v2-payment-request-button" className={this.state.walletAvailable ? "v2-wallet-button" : "v2-wallet-button hidden"} />
                                    {this.state.walletAvailable ? <div className="v2-payment-divider"><span>or pay by card</span></div> : null}
                                    <div id="v2-stripe-card-element" className="v2-stripe-card-element" />
                                </>
                            ) : (
                                <>
                                    <input placeholder="Name on card" value={this.state.cardName} onChange={(e) => this.update("cardName", e.target.value)} />
                                    <input placeholder="Card number" value={this.state.cardNumber} onChange={(e) => this.update("cardNumber", e.target.value)} />
                                    <div className="v2-card-row">
                                        <select value={this.state.expiryMonth} onChange={(e) => this.update("expiryMonth", e.target.value)}>
                                            <option value="">Month</option>
                                            {this.expiryMonths().map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </select>
                                        <select value={this.state.expiryYear} onChange={(e) => this.update("expiryYear", e.target.value)}>
                                            <option value="">Year</option>
                                            {this.expiryYears().map((year) => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </select>
                                        <input placeholder="CVC" value={this.state.cvc} onChange={(e) => this.update("cvc", e.target.value)} />
                                    </div>
                                </>
                            )}
                        </div>
                        {event.addressRequired ? (
                            <div className="v2-form-section">
                                <h3>Address details</h3>
                                <div className="v2-card-row">
                                    <input placeholder="No." value={this.state.addressNumber} onChange={(e) => this.update("addressNumber", e.target.value)} />
                                    <input placeholder="Street" value={this.state.addressStreet} onChange={(e) => this.update("addressStreet", e.target.value)} />
                                </div>
                                <div className="v2-card-row">
                                    <input placeholder="Suburb" value={this.state.addressSuburb} onChange={(e) => this.update("addressSuburb", e.target.value)} />
                                    <input placeholder="Postcode" value={this.state.addressPostcode} onChange={(e) => this.update("addressPostcode", e.target.value)} />
                                </div>
                                <input placeholder="State" value={this.state.addressState} onChange={(e) => this.update("addressState", e.target.value)} />
                            </div>
                        ) : null}
                        <p className="v2-terms-copy">
                            By purchasing tickets you agree to the <button onClick={() => this.setState({ showTerms: true })}>Terms and Conditions</button>.
                        </p>
                        {this.state.message ? <p className="v2-error-message">{this.state.message}</p> : null}
                        <button className="v2-primary-action" disabled={this.state.loading || selectedDisabled || !selected || !event.termsSnapshot} onClick={this.submit}>
                            {selectedDisabled
                                ? "Choose a smaller bundle"
                                : this.state.loading
                                    ? "Processing..."
                                    : "Buy " + selected.tickets + " tickets for $" + selected.price}
                        </button>
                    </section>
                    <V2PoweredBy className="v2-buy-page-powered" />
                </main>
            </div>
        )
    }
}

export default withRouter(V2BuyTickets)
